@if (address()) {
  <div class="inline-flex items-center">
    <app-ui-icon
      class="mr-1"
      color="var(--grey-3)"
      name="marker"
      size="sm"
    ></app-ui-icon>
    <a
      (click)="openMap()"
      class="text-green-2 text-sm hover:text-green-1"
    >
      {{ address() }}
    </a>
  </div>
}

@if (careproviderUnit().reviewSummary.reviews > 0) {
  <div class="flex flex-row items-start gap-0.5">
    <app-ui-icon
      [name]="'star_filled'"
      [size]="'sm'"
      color="var(--apricot-1)"
    ></app-ui-icon>
    <span class="text-grey-0 font-medium text-sm">{{ careproviderUnit().reviewSummary.rating | round:1 }} <span
      class="text-grey-6 font-normal text-sm">({{ careproviderUnit().reviewSummary.reviews }})</span></span>
  </div>
}


@if (!isMobile() && careproviderUnit().serviceHours && careproviderUnit().serviceHours?.surgeryHours && careproviderUnit().serviceHours?.surgeryHours.length > 0) {
  <app-openning-hours-small-v2
    [openHours]="careproviderUnit().serviceHours?.surgeryHours"
    class="hidden 3xl:inline-block"
  ></app-openning-hours-small-v2>
}

